import { render, staticRenderFns } from "./DataResetManagement.vue?vue&type=template&id=4a44e53c&scoped=true"
import script from "./DataResetManagement.vue?vue&type=script&lang=js"
export * from "./DataResetManagement.vue?vue&type=script&lang=js"
import style0 from "./DataResetManagement.vue?vue&type=style&index=0&id=4a44e53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a44e53c",
  null
  
)

export default component.exports